import { FormStateType } from "../../../../types";
import { CLAIM_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [CLAIM_INFORMATION_CONSTANTS.DATE_OF_LOSS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_FIRST_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_LAST_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.INSURER_OR_REPRESENTATIVE_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_ADDRESS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_1]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_2]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.COUNTRY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_EMAIL]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_PHONE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.INCIDENT_TYPE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.DESCRIPTION_OF_INCIDENT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.COUNTRY_WHERE_INCIDENT_OCCURRED]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_INFORMATION_CONSTANTS.PRODUCT_PURCHASE_DATE]: {
    value: "",
    errors: [],
    hidden: false,
  },
};